import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import aiLabelStyles from '../../helpers/ai-label.module.css';
import { buildImageSrcSet, buildImageUrl, createAvifSourceElement, getImageDimensions, isSvgImage } from './Picture.helpers';
import styles from './Picture.module.css';
export const Picture = ({ asset, description, isBackground, isFullWidth, loading = 'lazy', sizes = '(max-width: 768px) 100vw, 560px', className, ...props })=>{
    if (!asset?.filename) {
        return null;
    }
    const isSvg = isSvgImage(asset.filename);
    const imageClassName = classNames(styles.image, isBackground && styles.fill, isFullWidth && styles['full-width']);
    const pictureClassName = classNames(className, aiLabelStyles['ai-label'], aiLabelStyles['ai-label']);
    const aiLabel = asset.meta_data?.ai_label?.trim();
    const [width, height] = getImageDimensions(asset.filename) ?? [
        1024,
        0
    ];
    if (isSvg) {
        return /*#__PURE__*/ _jsx("picture", {
            ...props,
            className: pictureClassName,
            "data-ai-label": aiLabel,
            children: /*#__PURE__*/ _jsx("img", {
                alt: asset.alt || description,
                className: imageClassName,
                fetchPriority: loading === 'eager' ? 'high' : 'auto',
                loading: loading,
                src: asset.filename,
                decoding: "async",
                width: width,
                height: height
            })
        });
    }
    const imageSizes = loading === 'lazy' ? `auto, ${sizes}` : sizes;
    return /*#__PURE__*/ _jsxs("picture", {
        ...props,
        className: pictureClassName,
        "data-ai-label": aiLabel,
        children: [
            createAvifSourceElement(asset.filename, imageSizes),
            /*#__PURE__*/ _jsx("img", {
                alt: asset.alt || description,
                className: imageClassName,
                fetchPriority: loading === 'eager' ? 'high' : 'auto',
                height: height,
                loading: loading,
                src: buildImageUrl(asset.filename, width),
                srcSet: buildImageSrcSet(asset.filename),
                width: width,
                sizes: imageSizes,
                decoding: "async"
            })
        ]
    });
};

//# sourceMappingURL=Picture.js.map